import React, {memo} from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

/* Components */
import TechSpecsTable from './tech-specs-table/TechSpecsTable'

/* Utils */
import DataSet from '../../../../utils/DataSet'

/* Styles */
import s from './tech-specs.scss'

const TechSpecs = memo(({
  className,
  techSpecs,
  pageTypeForDavinci,
  sku,
  productId,
  merchantId,
  merchantName,
  listingId,
  price
}) => {
  return (
    <div
      className={cx(s.root, className)} id={'techSpecs'} data-test-id={'KeyFeaturesTable'} data-hbus={
        DataSet.createComponentViewDataForDavinci({
          placement: 'Product Description',
          component: 'Key Features Table',
          componentDetail: 'Ürün Bilgileri',
          pageType: pageTypeForDavinci,
          pageValue: sku,
          productId: productId,
          merchantName: merchantName,
          merchantId: merchantId,
          listingId: listingId || '',
          price: `${price}`
        })}>
      <div className={s.titleText}>
        {'Ürün özellikleri'}
      </div>
      {
        techSpecs?.length > 0 &&
        <TechSpecsTable techSpecs={techSpecs?.[0]?.properties}/>
      }
      {
        techSpecs?.length > 1 &&
        <>
          <div className={s.titleText}>
            {'Diğer'}
          </div>
          <TechSpecsTable techSpecs={techSpecs?.[1]?.properties} className={s.full}/>
        </>
      }
    </div>
  )
})

TechSpecs.propTypes = {
  className: PropTypes.string,
  techSpecs: PropTypes.array.required
}

export default TechSpecs
